import {inject, Injectable, Injector} from "@angular/core"
import {DataResolverService} from "@app/material-editor/services/data-resolver.service"
import {DataObjectContentCache} from "@app/template-editor/helpers/data-object-content-cache"
import {DecalMeshDataCache} from "@app/template-editor/helpers/decal-mesh-data-cache"
import {GeometryDataCache} from "@app/template-editor/helpers/geometry-data-cache"
import {ImageDataCache} from "@app/template-editor/helpers/image-data-cache"
import {MaterialGraphCache} from "@app/template-editor/helpers/material-graph-cache"
import {MeshDataCache} from "@app/template-editor/helpers/mesh-data-cache"
import {TemplateRevisionGraphCache} from "@app/template-editor/helpers/template-revision-graph-cache"
import {DataObjectSizeCache} from "@app/template-editor/helpers/data-object-size-cache"

@Injectable({
    providedIn: "root",
})
export class SceneManagerCacheService {
    private readonly injector = inject(Injector)
    readonly dataResolverService = inject(DataResolverService)

    meshCache = new MeshDataCache(this.injector)
    decalMeshCache = new DecalMeshDataCache(this.injector)
    dataObjectSizeCache = new DataObjectSizeCache()
    templateRevisionGraphCache = new TemplateRevisionGraphCache(this.injector)
    materialGraphCache = new MaterialGraphCache(this.injector)
    geometryDataCache = new GeometryDataCache(this.injector)
    dataObjectContentCache = new DataObjectContentCache()
    imageDataCache = new ImageDataCache(this.dataObjectContentCache)
}
